import React from "react";
import { ToolTipProps } from "../../../../../types/dashboard.types";
import "../../style/tooltip.css";
import { IoInformationCircleOutline } from "react-icons/io5";
import { Text } from "theme-ui";
const ProjectOverviewIButton = ({
    description,
}: ToolTipProps) => {
    return (
        <div className="cb-tooltip-wrapper">
            <span className="cb-tooltip-trigger"><IoInformationCircleOutline /></span>
            <div className="cb-tooltip-content">
                <Text>{description}</Text>
            </div>
        </div>
    );
}
export default React.memo(ProjectOverviewIButton)